
export class TravserseModel {

  onDemandLoading: Boolean
  filterByName: string;
  uri: string;
  type: string;
  prefix: string;
  location?: any;
}

export class EmailResponse {
  id?: string;
  href?: string;
  name: string;
  type?: string;
  successful: boolean;
  emailType: string;
}


export class ContentResponse {
  content: string;
  contentType: string;

  constructor(
    content?: string,
    contentType?: string
  ) {
    this.content = content;
    this.contentType = contentType;
  }
}

export class Reference {
  id?: string;
  href?: string;
  startDate?: string;
  endDate?: string;
}

export class Dictionary {

  _keys: string[];
  _values: any[];

  // TODO: Add optional object parameter to allow creation of static mock dictionaries in other mock objects - KJC
  constructor() {
    this._keys = [];
    this._values = [];
  }

  add(key: string, value: any) {
    this[key] = value;
    var index = this._keys.indexOf(key, 0);
    if (index >= 0) {
      this._values[index] = value;
    } else {
      this._keys.push(key);
      this._values.push(value);
    }
  }

  remove(key: string) {
    var index = this._keys.indexOf(key, 0);
    if (index >= 0) {
      this._keys.splice(index, 1);
      this._values.splice(index, 1);
    }

    delete this[key];
  }

  keys(): string[] {
    return this._keys;
  }

  values(): any[] {
    return this._values;
  }

  containsKey(key: string) {
    if (typeof this[key] === "undefined") {
      return false;
    }
    return true;
  }

  // Specially for Eligibility call
  getPostdataUrl(dataObj: any) {
    let postdata: string = "data=";
    for (let i: number = 0; i < dataObj._keys.length; i++) {
      postdata += dataObj._keys[i] + ":" + encodeURIComponent((dataObj[dataObj._keys[i]] as string).trim()) + ";";
    }
    postdata = postdata.substring(0, postdata.length - 1);
    return postdata;
  }

  static DictionaryFromArrayPair(keys: string[], values: any[]): Dictionary {
    let dict = new Dictionary()

    if (
      !!keys &&
      !!keys.length &&
      !!values &&
      !!values.length &&
      keys.length === values.length
    ) {
      keys.forEach((key: string, i: number) => {
        dict.add(key, values[i]);
      });
    }

    return dict;
  }
}